module.exports = __webpack_public_path__ + "static/img/fb.015b585.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/community/fb.png
// module id = K3xJ
// module chunks = 7